var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalNowinBgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 279,
    viewBox: "0 0 327 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6829 246.536C89.5706 241.695 115.664 240.708 140.945 236.973C166.227 233.232 191.858 226.132 207.963 212.079C224.854 197.337 228.634 177.421 241.087 160.674C261.869 132.729 304.084 116.423 342.887 100.241C375.335 86.7121 408.861 70.3996 426 47.6883L426 -26L-14 -26L-14 279C7.61215 263.699 34.9716 252.31 64.6829 246.536Z",
    fill: "#FFECEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalNowinBgLight);
export default __webpack_public_path__ + "static/media/modal_nowin_bg_light.9bf00d326d1ef5c7f8f4a955e53b5bc0.svg";
export { ForwardRef as ReactComponent };